"use client";

import "@fontsource-variable/inter";
import "@fontsource/poppins/latin-600.css";
import "@fontsource/poppins/latin-700.css";
import { CssBaseline, ThemeProvider } from "@mui/material";
import type { ReactNode } from "react";
import { theme } from "@/theme/theme";

export default function ThemeRegistry({ children, defaultMode = "light" }: { children: ReactNode; defaultMode?: "light" | "dark" }) {
  return (
    // The default look from Admin → Settings until the person chooses their own (owner, 2026-10-24).
    <ThemeProvider theme={theme} defaultMode={defaultMode}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
